// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2TV8B","footer":"ModalInfo_footer__2FR19"};